import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSetWSStore, useWSStore } from "../store";
import { getGrowthSourceFromPathname } from "./growthAttribution";

export const HistoryListener: React.FC = ({ children }) => {
  const location = useLocation<any>();
  const store = useWSStore();
  const setStore = useSetWSStore();

  useEffect(() => {
    const { search, pathname } = location;
    const params = new URLSearchParams(search);

    if (pathname.includes("sign-up")) {
      let growthSource;

      if (!store.growthAttributionDetails) {
        let growthAttributionDetails;
        try {
          // Check the pathname for a growth source
          growthSource = getGrowthSourceFromPathname(location);

          if (growthSource) {
            // Gather other growth data
            const growthName = params.get("growth_name") || undefined;
            const growthUserId = params.get("growth_user_id") || undefined;

            // Save everything in the store for use later
            growthAttributionDetails = {
              growthSource: growthSource.source,
              growthName,
              growthUserId
            };
          }
        } catch (e) {
          console.error(e);
        }

        growthAttributionDetails && setStore({ growthAttributionDetails });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return <>{children}</>;
};
